export { validate } from './validate/index.js'
export { default as bus } from './bus/index.js'
export { default as loadMore } from './loadmore'
export { linkTo, toLogin } from './linkTo'
export { formatDate } from './formatDate'
export { formatImage } from './formatImage'

export function round (number, precision = 2, type = 'string') {
  const count = Math.round(+number + 'e' + precision) / Math.pow(10, precision)
  if (type === 'number') {
    return count
  }
  return count.toFixed(precision)
}

export function formatInteger (num) {
  const integer = Math.round(num)
  if (integer < 10) return `0${integer}`
  return integer
}

export function preventWindowScroll (flag) {
  if (flag) {
    const temp = document.documentElement.classList.contains('hidden')
    if (temp) {
      document.documentElement.classList.add('hidden-1')
    } else {
      document.documentElement.classList.add('hidden')
    }
  } else {
    const temp = document.documentElement.classList.contains('hidden-1')
    if (temp) {
      document.documentElement.classList.remove('hidden-1')
    } else {
      document.documentElement.classList.remove('hidden')
    }
  }
}

export function openLink (link, target = '_blank') {
  const a = document.createElement('a')
  a.href = link
  a.target = target
  a.click()
}

export function getStylePropertyValue (style, prop) {
  const el = document.createElement('div')
  el.style.cssText = style
  return el.style.getPropertyValue(prop)
}

export function testLink (link, rules) {
  try {
    if (link.startsWith('/')) return true
    const index = rules.findIndex(r => {
      const re = new RegExp(r.replace('*.', '([\\w-]+.)*').replace('.', '\\.'), 'i')
      return re.test(link)
    })
    return index > -1
  } catch (error) {
    console.log(error)
    return false
  }
}
